import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { IFormAssetTracking } from '@components/modals/CreateEditAssetTrackingModal/constants/schemaAssetTracking';
import { gpsTrackerSelectKey } from '@components/modals/CreateEditAssetTrackingModal/services/useGPSTrackerSelectQuery';

import { apiClient } from '@services/apiClient';

import { gpsAssetsKey } from './useGPSAssetsQuery';
import { gpsTrackerKey } from './useGPSTrackersQuery';

const gpsAssetSaveFn = (data: IFormAssetTracking, gpsAssetId?: number | string) => {
  if (gpsAssetId) {
    return apiClient.put(`${APP_API_URL_V2}fsd/gps-asset/${gpsAssetId}`, data);
  }

  return apiClient.post(`${APP_API_URL_V2}fsd/gps-asset`, data);
};

export const useGPSAssetSaveMutation = ({ gpsAssetId }: { gpsAssetId?: number | string }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: IFormAssetTracking) => gpsAssetSaveFn(data, gpsAssetId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [gpsTrackerKey({})[0]] });
      queryClient.invalidateQueries({ queryKey: [gpsTrackerSelectKey()[0]] });
      queryClient.invalidateQueries({ queryKey: [gpsAssetsKey({})[0]] });
    },
  });
};
